export const getPermissionIdFromDashboardPermissionId = (dashboardPermissionId: string) => {
    return dashboardPermissionId.split('-')[1];
};
